import { IconButton, ListItem, SvgIcon } from '@mui/material';
import XIcon from '@untitled-ui/icons-react/build/esm/XClose';
import { cloneElement, useRef } from 'react';
import toast from 'react-hot-toast';

const ToastMessage = ({ toastId, children }) => {
  const toastRef = useRef(null);

  const handleHideToast = () => {
    if (toastRef.current) {
      // Tìm parent có position: fixed
      let parentWithClass = toastRef.current;
      while (parentWithClass && !parentWithClass.classList.contains('host-toaster-parent')) {
        parentWithClass = parentWithClass.parentElement;
      }

      // Nếu tìm thấy parent có position: fixed, thay đổi style của nó
      if (parentWithClass) {
        parentWithClass.style.visibility = 'hidden'; // Ví dụ: đổi màu nền
      }
    }
  };

  const handleShowToast = () => {
    if (toastRef.current) {
      // Tìm parent có position: fixed
      let parentWithClass = toastRef.current;
      while (parentWithClass && !parentWithClass.classList.contains('host-toaster-parent')) {
        parentWithClass = parentWithClass.parentElement;
      }

      // Nếu tìm thấy parent có position: fixed, thay đổi style của nó
      if (parentWithClass) {
        parentWithClass.style.visibility = 'visible'; // Ví dụ: đổi màu nền
      }
    }
  };
  return (
    <ListItem
      ref={toastRef}
      sx={{
        alignItems: 'flex-start',
        paddingLeft: 0,
        paddingBottom: 0,
        paddingTop: 0,
        paddingRight: 4,
        '& .MuiListItemSecondaryAction-root': {
          top: '10px',
          right: '-10px'
        }
        // ...(unread && { background: '#deff7a12' })
      }}
      secondaryAction={
        <IconButton edge="end" size="small" onClick={() => toast.remove(toastId)}>
          <SvgIcon>
            <XIcon />
          </SvgIcon>
        </IconButton>
      }
    >
      {cloneElement(children, {
        handleHideToast: handleHideToast,
        handleShowToast: handleShowToast,
        toastId: toastId
      })}
    </ListItem>
  );
};

export default ToastMessage;
